import { useEffect } from 'react';
import { useAppDispatch } from '../Store/store';
import { logout, syncLogin } from '../Slice/userSlice';

const useStorageListener = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      // Check if auth-token was removed
      if (e.key === 'auth-token') {
        if (e.newValue === null) {
          dispatch(logout());
        } else {
          const id = localStorage.getItem("id");
          const role = localStorage.getItem("role");
          dispatch(syncLogin({ id, role }));
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [dispatch]);
};

export default useStorageListener;